// region Please kill jQuery

// import $ from 'jquery';
// import {Foundation} from 'foundation-sites/js/foundation.core';
// import {MediaQuery} from 'foundation-sites/js/foundation.util.mediaQuery';

// Set up Foundation with jQuery.
// Foundation.addToJquery($);
// Foundation JS init here:
// Foundation.MediaQuery = MediaQuery;

// ...
// $(document).foundation();
// // Add jQuery to window for temp back compat.
// window.$ = $;

// endregion

import * as Tools from './tools';

//import {initTicketForm, initTicketModal} from './tickets';

import 'lazysizes';
import initAnalytics from './analytics/analytics';
import initLightbox from './plugins/lightbox';
import initMenu from './plugins/menu';
//import {initSalAnimations} from "./plugins/animation";
import {initInviewObserver} from "./IntersectionObserver";
import {initModal} from './plugins/modal';
import {
    initHomePageSlider,
    initGalleryElementCarousel1,
    initGalleryElementCarousel2,
    initEmployeeSlider, initShortcutSlider
} from './plugins/carousels'
import {initSticky} from "./plugins/sticky";
import {initAnimationObserver} from "./plugins/animation";
//import {initSweetAlert} from "./plugins/sweetalert";
import initPageform from "./plugins/pageform";
// import initMap from './plugins/map';
import initListFilter from "./plugins/listfilter";
import initGroupform from "./plugins/groupform";
import {initHeader} from "./plugins/header";
import {initSimpleParallax} from "./plugins/parallax";
import initGiftcardForm from "./plugins/giftcard";
import initErrorScroll from "./plugins/errorscroll";
import initCart from "./Shop/cart";
import {initExpiry} from "./cart";
import fetchOpeningHours from "./plugins/openinghoursegoogle";
import {initPlayPauseVideo} from "./plugins/playpausevideo";
import {initPopup} from "./plugins/popup";

window.Tools = Tools;

document.addEventListener('DOMContentLoaded', () => {
	initAnalytics();
    initInviewObserver();
    initErrorScroll()
    initAnimationObserver();
    //initSweetAlert();
	initPageform();
    initGiftcardForm()
    initGroupform();
    initLightbox();
	initMenu();
	initHeader();
	//initSticky()
    //initSalAnimations();
    //initMap();
	initModal();
    initHomePageSlider();
    initEmployeeSlider();
    initGalleryElementCarousel1();
    initGalleryElementCarousel2();
    initShortcutSlider();
    initListFilter();
    initSimpleParallax();
    initCart();
    initExpiry();
    initPlayPauseVideo();
    initPopup();
    // fetchOpeningHours();
});

// If in development mode, enable live reload
if (ENV !== 'production') {
    document.write(
        '<script src="http://' + (location.host || 'localhost').split(':')[0] +
        ':35729/livereload.js?snipver=1"></' + 'script>'
    );
}

//Focus on Search window load
window.onload = function() {
    var input = document.getElementById("SearchForm_SearchForm_Search");
    if (input) {
        input.setAttribute("placeholder", "Enter a search phrase here");
        input.focus();
        var val = input.value; //store the value of the element
        input.value = ''; //clear the value of the element
        input.value = val; //set that value back.
    }
}
